import React, { useMemo, useState } from 'react';
import { Alert, Box, Tab, Tabs, Typography } from '@mui/material';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { UserDTO } from '../../../../models/userDTO';
import SupplierGroupsTab from './SupplierGroupsTab';
import SuppliersTab from './SuppliersTab';
import { ADDRESS_ADMINISTRATION_MODIFY, hasAdministrationPermission, SUPPLIER_ADMINISTRATION_MODIFY } from './permissions';

type SupplierAdministrationPartProps = {
	user: UserDTO;
}

type LocalTabPanelProps = {
	value: number;
	index: number;
	children: React.ReactNode;
}

const LocalTabPanel = ({ value, index, children }: LocalTabPanelProps) => {
	return (
		<Box role="tabpanel" hidden={value !== index} sx={{ mt: 2 }}>
			{value === index && children}
		</Box>
	);
};

const SupplierAdministrationPart = ({ user }: SupplierAdministrationPartProps) => {
	const [value, setValue] = useState(0);

	const canModifySuppliers = useMemo(
		() => hasAdministrationPermission(user, SUPPLIER_ADMINISTRATION_MODIFY),
		[user]
	);
	const canModifyAddresses = useMemo(
		() => hasAdministrationPermission(user, ADDRESS_ADMINISTRATION_MODIFY),
		[user]
	);

	return (
		<Box sx={{ width: '100%' }}>
			<Typography variant="h4" color="primary" sx={{ mb: 2 }}>
				Administration des fournisseurs
			</Typography>
			{!canModifySuppliers && (
				<Alert severity="info" sx={{ mb: 2 }}>
					Vous disposez d'un accès en lecture seule sur cette administration.
				</Alert>
			)}
			<Tabs value={value} onChange={(_, newValue: number) => setValue(newValue)} variant="scrollable" scrollButtons="auto">
				<Tab label="Groupes fournisseurs" />
				<Tab label="Fournisseurs" />
			</Tabs>
			<LocalTabPanel value={value} index={0}>
				<SupplierGroupsTab canModify={canModifySuppliers} />
			</LocalTabPanel>
			<LocalTabPanel value={value} index={1}>
				<SuppliersTab canModify={canModifySuppliers} canCreateAddress={canModifyAddresses} />
			</LocalTabPanel>
			<ToastContainer />
		</Box>
	);
};

export default SupplierAdministrationPart;
